import $ from "jquery";

const popupSurvey = () => {
  const init = () => {
    survey();
  };

  const survey = () => {
    const el = {
      triggerButton: ".js-PopupSurvey--Button",
      popup: ".js-PopupSurvey--Popup",
      popupOverlay: ".js-PopupSurvey--Popup__Overlay",
      popupChapterStep: ".js-SurveyPopup--Chapter",
      popupChapterStep_Button: ".js-SurveyPopup--Chapter__Button",
      popupChapterComplete: ".js-SurveyPopup--Chapter__Complete",
      popupChapterComplete_Button:
        ".js-SurveyPopup--Chapter__Complete--CloseButton",
    };

    // TRIGGER POPUP
    // $(el.popup).hide();

    function triggerPopup() {
      $(el.popup).fadeIn();
      $(el.popupOverlay).show();
      $(el.popup).css('display', 'flex')
    }

    $(el.triggerButton).on("click", function () {
      triggerPopup();
    });
    // END TRIGGER POPUP

    // ===============================================================

    // SURVEY CHAPTERS
    $(el.popupChapterStep).attr("open", true).show();
    $(el.popupChapterComplete).attr("open", false).hide();

    function questionSurvey(el) {
      const data = el.data("target");

      if (data === "Chapter__Complete--Survey") {
        $(".js-SurveyPopup--Chapter").attr("open", false).hide();
        // $(".js-Chapter__Content").attr("open", true).show();
        $(".js-SurveyPopup--Chapter__Complete").attr("open", true).show();
      }
    }

    function finishSurvey() {
      $(".js-SurveyPopup--Chapter__Complete").attr("open", false).hide();
      $(".js-PopupSurvey--Popup").hide();
    }

    $(el.popupChapterStep_Button).on("click", function () {
      questionSurvey($(this));
    });

    $(el.popupChapterComplete_Button).on("click", function () {
      finishSurvey($(this));
    });
  };

  init();
};

try {
  popupSurvey();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
